import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, BodyText } from '@chargify/custom-ui-components';
import { ErrorTypes } from '../../../../../machines/changePlan/types';

type Props = {
  error: ErrorTypes;
};
export const ErrorAlert = ({ error }: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);
  const description =
    error === 'CardDeclined'
      ? t('plan_change.credit_card_declined')
      : t('plan_change.unexpected_error_description');

  const title =
    error === 'CardDeclined'
      ? t('plan_change.credit_card_declined_title')
      : t('plan_change.unexpected_error_title');
  return (
    <Alert color={'danger'} title={title}>
      <BodyText variant="body2" color="danger.dark">
        {description}
      </BodyText>
    </Alert>
  );
};
